import { useQuery, useMutation } from '@tanstack/react-query'
import { consumeSyndicationCredits } from '@/models/plans/apis'
import { purchasePackageWithCoupon, purchasePackage } from '@/models/plans/apis'

export const useConsumeSyndication = () => {
  const sponsorListing = useMutation({
    mutationFn: ({
      items,
      listingId
    }: {
      items: { plan_name: string; platform: string; quantity: number }[]
      listingId: string
    }) => {
      return consumeSyndicationCredits(
        {
          body: { items, listing_id: Number(listingId) }
        },
        { listingId }
      )
    },
    onSuccess: async data => {}
  })

  return sponsorListing
}

export const usePurchaseSyndication = () => {
  const purchaseSyndication = useMutation({
    mutationFn: async ({
      paymentMethodId,
      items,
      metadata,
      couponCode
    }: {
      paymentMethodId: string
      items: { quantity: number; priceId: string }[]
      metadata: { pLink: string }
      couponCode?: string | null | undefined
    }) => {
      const purchasePackageCaller = couponCode ? purchasePackageWithCoupon : purchasePackage
      return purchasePackageCaller(
        {
          payment_method_id: paymentMethodId,
          items,
          metadata
        },
        { couponCode }
      )
    }
  })
  return purchaseSyndication
}
